const BUILD_MODE = import.meta.env.MODE

const MODE_CLASS: Record<string, string> = {
  dev: 'bg-[#F5C518] text-[#191919]',
  'dev-ec2': 'bg-[#FF6600] text-white',
  development: 'bg-[#2563eb] text-white',
}

const BuildEnvBanner = () => {
  if (BUILD_MODE === 'prd') return null

  const colorClass = MODE_CLASS[BUILD_MODE] ?? 'bg-[#333333] text-white'

  return (
    <div
      role="status"
      aria-label={`현재 빌드 환경: ${BUILD_MODE}`}
      className={`sticky top-0 z-[200] flex h-8 w-full items-center justify-center gap-2 text-xs font-bold tracking-wide ${colorClass}`}
    >
      <span className="opacity-80 font-semibold">환경</span>
      <span>{BUILD_MODE}</span>
    </div>
  )
}

export default BuildEnvBanner
